import {
  useIssueMicrosoftOAuthUrlMutation,
  useStoreMicrosoftOAuthCredentialForPlannerAccountMutation,
  useRevokeMicrosoftOAuthTokenForPlannerAccountMutation,
} from './useMicrosoftAuthorization.generated'
import { OAuthProvider } from '@/types/schema.generated'

export const useMicrosoftAuthorizationForPlannerAccount = () => {
  const { location } = document
  // 社内セキュリティで設定しているエンプラ企業もあるので、redirectUriは基本的に変更禁止
  const redirectUri = `${location.protocol}//${location.host}/settings/calendar-auth/callback?type=plannerAccount`

  const issueOAuthUrlMutation = useIssueMicrosoftOAuthUrlMutation()
  const issueOAuthUrl = async () => {
    const res = await issueOAuthUrlMutation.mutate({
      redirectUri: redirectUri,
    })
    if (res?.data) {
      return res.data.issueMicrosoftOAuthURL.url
    }
    throw new Error(`error issueOAuthUrl: ${res}`)
  }

  const storeOAuthCredentialMutation =
    useStoreMicrosoftOAuthCredentialForPlannerAccountMutation()
  const storeOAuthCredential = (code: string) => {
    return storeOAuthCredentialMutation.mutate({
      code,
      redirectUri,
    })
  }

  const revokeOAuthTokenMutation =
    useRevokeMicrosoftOAuthTokenForPlannerAccountMutation()

  const revoke = async () =>
    await revokeOAuthTokenMutation.mutate({
      input: {
        provider: OAuthProvider.Microsoft,
      },
    })

  return {
    // TODO
    issueOAuthUrl,
    storeOAuthCredential,
    revoke,
  }
}
